var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress",style:(`width: ${_vm.progress()}%`)},[(_vm.duck % 3 === 0)?_c('img',{class:{
        forest: _vm.currentTheme === 'forest',
        ocean: _vm.currentTheme === 'ocean',
        invert: _vm.currentTheme === 'dark',
        sepia: _vm.currentTheme === 'sepia',
      },attrs:{"src":require("../assets/duck0.png")}}):(_vm.duck % 3 === 1)?_c('img',{class:{
        forest: _vm.currentTheme === 'forest',
        ocean: _vm.currentTheme === 'ocean',
        invert: _vm.currentTheme === 'dark',
        sepia: _vm.currentTheme === 'sepia',
      },attrs:{"src":require("../assets/duck1.png")}}):(_vm.duck % 3 === 2)?_c('img',{class:{ forest: _vm.currentTheme === 'forest', ocean: _vm.currentTheme === 'ocean', invert: _vm.currentTheme === 'dark', sepia: _vm.currentTheme === 'sepia' },attrs:{"src":require("../assets/duck2.png")}}):_c('img',{class:{
        forest: _vm.currentTheme === 'forest',
        ocean: _vm.currentTheme === 'ocean',
        invert: _vm.currentTheme === 'dark',
        sepia: _vm.currentTheme === 'sepia',
      },staticStyle:{"float":"right"},attrs:{"src":require("../assets/duck0.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }